




































































































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm } from "@/store";
import { ILocationFromParticle } from "@/models/AlarmStatus";
import differenceInMilliseconds from "date-fns/differenceInMilliseconds";
import parseISO from "date-fns/parseISO";
import addMinutes from "date-fns/addMinutes";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        SensorModule: () =>
            import(/* webpackChunkName: "components" */ "./SensorModule.vue"),
        Battery: () =>
            import(
    /* webpackChunkName: "components" */ "@/views/components/BatteryView.vue"
            ),
        ConfirmDialog: () =>
            import(
    /* webpackChunkName: "settings" */ "@/views/components/Dialogs/ConfirmDialog.vue"
            )
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(_, { attrs }) {
        //let gpsAgeMinutes = 0;
        let lastGpsTime: Date | null;

        const showResetConfirm = ref<boolean>(false);
        const showRestartConfirm = ref<boolean>(false);


        const voltage = computed<number>(() => {
            let value = -1;
            if (alarm && alarm.alarmStatus && alarm.alarmStatus.VSupplies) {
                const vSupplies = alarm.alarmStatus.VSupplies[0];
                value = vSupplies.V3 === "NotPresent" ? -1 : parseFloat(vSupplies.V3);
            }
            return value;
        });

        const boatPower = computed(() => {
            if (
                alarm.alarmStatus !== null &&
                alarm.alarmStatus.VSupplies[0] !== null
            ) {
                const voltage = alarm.alarmStatus.VSupplies[0].V1;
                return voltage === "NotPresent" ? false : true;
            }
            return -1;
        });

        const voltageWarning = computed(() => {
            if (voltage.value === -1) {
                return false;
            }
            if (voltage.value < 3.3 || voltage.value > 4.2) {
                return true;
            }
            else {
                return false;
            }
        });

        const gsmCloud = computed<boolean>(() => {
            return true;
        });
        const reset = () => {
            alarm.reset();
            showResetConfirm.value = false;
        };
        const restart = () => {
            alarm.restart();
            showRestartConfirm.value = false;
        };
        const initReset = () => {
            showResetConfirm.value = true;
        };
        const initRestart = () => {
            showRestartConfirm.value = true;
        };
        const isActive = computed<boolean>(() => {
            return attrs.isActive == null ? false : true;
        });

        //const gpsAge = (loc: ILocationFromParticle | null): void => {
        //    if (loc) {
        //        lastGpsTime = lastGpsTime == null ? loc.location.lastHeard : null;
        //        var date = parseISO(loc.location.lastHeard.toString());
        //        // Update the count down every 1 second
        //        const now = parseISO(new Date().toISOString());
        //        // Find the distance between now and the count down date
        //        const gpsTime = addMinutes(date, now.getTimezoneOffset() * -1);

        //        const distance = differenceInMilliseconds(now, gpsTime);
        //        // Time calculations for days, hours, minutes and seconds
        //        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        //        var hours = Math.floor(
        //            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        //        );
        //        gpsAgeMinutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        //    }
        //};
        const gpsConnected = computed<boolean>(() => {
            return alarm.lastKnownLocation.location ? alarm.lastKnownLocation.location.gps_lock : false;
            //gpsAge(alarm.lastKnownLocation);
            //if (gpsAgeMinutes < 10) {
            //    return true;
            //} else {
            //    return false;
            //}
        });

        return {
            showResetConfirm,
            showRestartConfirm,
            restart,
            reset,
            initReset,
            initRestart,
            voltage,
            boatPower,
            gpsConnected,
            gsmCloud,
            voltageWarning,
            isActive
        };
    }
});
